<template>
    <div class="row no-gutters ml-3 mr-3">
        <div class="col-6 ">
            <div class="shadow card mr-2 mb-4" v-if="savedProfileVideoLink == null">
                <div class="row no-gutters mb-3">
                    <div class="col ml-3 mt-3">
                        <img src="../../assets/VideoProfile.svg" alt="videoimg" class="img-fluid vdimage" />
                        <label class="fontsize14 proximanova-semibold black ml-2 mr-2">Video Profile</label>
                        <img src="../../assets/Info.svg" class="img-fluid red-tooltip proximanova" data-toggle="tooltip"
                            data-placement="bottom" alt="info"
                            data-original-title="The video must be between 15 to 60 seconds long"
                        />
                    </div>
                </div>
                <div class="row no-gutters mb-5" >
                    <div class="col d-flex justify-content-center">
                        <button class="btn btn-light mt-4 borderradius20 proximanova fontsize14 black" id="addvideobtn" @click="VideoProfileModalOpen">
                            <input type="file" class="form-control-file" id="exampleFormControlFile2"/>
                            <img :src="addprofilevideoimage" id="imagebtn" class="img-fluid mr-2" alt="add"/><span id="addtextprofile">Add</span>
                        </button>
                    </div>
                </div>
                <div class="row no-gutters vdtext">
                    <div class="col d-flex justify-content-center proximanova fontsize16 black60">Videos must be</div>
                </div>
                <div class="row no-gutters mb-5 vdtext">
                    <div class="col d-flex justify-content-center proximanova fontsize16 black60">between 15 to 60 seconds long</div>
                </div>
            </div>
            <div class="shadow card mr-2 mb-4 overlay-gradient" v-else>
                <div class="my-auto">
                    <video height="272" oncontextmenu="return false" @ended="onenddisplayreplayIcon('profile')" @waiting="displayLoadingLogo('profile')" @canplay="stopLoadingLogo('profile')" controlsList="nodownload"  id="profilevideo" >
                        <source :src="savedProfileVideoLink" id="profilevideosrctag">
                    </video>
                </div>
                <div class="card-img-overlay ">
                    <div class="row no-gutters mb-3 ml-0 mr-0 black_overlay1">
                        <div class="col ml-0 mt-3 d-flex videoheadsection">
                            <img src="../../assets/VideoProfile.svg" class="img-fluid vdimage" alt="videoimg"/>
                            <div class="d-flex flex-column">
                              <span class="fontsize14 proximanova-semibold white ml-2 mr-2 bold14px_white">Video Profile</span>
                              <span class="ml-2 mr-2 fontsize14 proximanova-semibold white bold14px_white">{{savedProfileVideoDate | moment("ll") }}</span>
                            </div>
                        </div>
                        <div class="pr-2 pr-lg-4 mt-3">
                            <span class="more_optionmenu more_option" id="moreactionprofilepop" v-popover:videoProfile>
                                <img src="../../assets/MoreActionsvideo.svg" width="4px" alt="moremenu" class="img-fluid">
                            </span>
                            <popover name="videoProfile" id="videoProfile">
                              <div class="p-2">
                                  <div class="d-flex p-1 justify-content-between">
                                    <span class="fontsize12 text-nowrap proximanova-bold black">More Actions</span>
                                    <div class="closebtnmouseover">
                                      <img src="../../assets/closebtn.svg" alt="close" class="img-fluid pr-1 closebtn" @click="closeVideoMoreActionsProfile">
                                    </div>
                                  </div>
                                  <div class="d-flex p-1 action" @click="EditProfileResumeVideo('PROFILE')">
                                      <img src="../../assets/Editvideo.svg" alt="editvideo" class="img-fluid pl-1 pr-1 ">
                                      <span class="pt-1 pl-2 d-flex flex-column">
                                        <div class="fontsize14 black80 proximanova">Edit</div>
                                      </span>
                                  </div>
                                  <!-- <div class="d-flex p-1 action">
                                      <img src="../../assets/Sharevideo.svg" alt="sharevideo" class="img-fluid pl-1 pr-1 ">
                                      <span class="pt-1 pl-2 d-flex flex-column">
                                        <div class="fontsize14 black80 proximanova">Share</div>
                                      </span>
                                  </div> -->
                                  <div class="d-flex p-1 action"  data-toggle="modal" data-target="#deleteprofileVideoModal"  @click="clickonDelete('profile')">
                                      <img src="../../assets/Deletevideo.svg" alt="deletevideo" class="img-fluid pl-1 pr-1">
                                      <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                        <div class="fontsize14 black80 proximanova">Delete</div> 
                                      </span>
                                  </div>
                              </div>
                            </popover>
                            <div class="modal backgroundnone fade confirmmodal" id="deleteprofileVideoModal" tabindex="-1" role="dialog" aria-labelledby="deleteprofileVideoModalLabel" aria-hidden="true">
                              <div class="modal-dialog " role="document">
                                <div class="modal-content pb-2">
                                  <div class="modal-header delete-modal pb-0">
                                    <h5 class="modal-title fontsize20 black80 proximanova" id="deleteprofileVideoModalLabel">Are you sure you want to delete this record ?</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body backgroundcolorwhite modal-delete text-center">
                                    <span class="button-cancel-font modaldeletebtn pointer border borderradius20 p-2 pr-4 pl-4 proximanova" data-dismiss="modal" aria-label="Close" >No</span>
                                    <span class="button-cancel-font backgroundcolorblack pointer borderradius20 white p-2 ml-2 pr-4 pl-4 proximanova"  @click="deleteVideo(profileVideoId, 'profile')">Yes</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <img src="../../assets/play_video.svg" v-if="!playingPorfileVideo" id="playvideobtn" alt="playvideo" @click="playProfileVideo">
                        <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingPorfileVideo && replayProfileVideo">
                            <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo('profile')">
                        </div>
                        <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingPorfileVideo && loadingProfileVideo">
                            <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                        </div>
                        <img src="../../assets/Pausevideo.svg" class="pausebtn" v-if="playingPorfileVideo && !replayProfileVideo && !loadingProfileVideo" alt="pausevideo" @click="playProfileVideo">
                    </div>
                    <div id="bottom">
                        <div class="black_overlay2">
                            <div class="pb-3 d-flex flex-column p-3">
                                <span v-if="savedProfileVideoTitle" class="bold16px_white fontsize16 white proximanova-semibold text-capitalize">{{savedProfileVideoTitle}}</span>
                                <span v-if="savedProfileVideoDescription" class="reg16px_white proximanova fontsize16 white60 text-capitalize">{{savedProfileVideoDescription}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="shadow card" v-if="savedResumeVideoLink == null">
                <div class="row no-gutters mb-3">
                    <div class="col ml-3 mt-3">
                        <img src="../../assets/VideoProfile.svg" alt="videoimg" class="img-fluid vdimage" />
                        <label class="fontsize14 proximanova-semibold black ml-2 mr-2">Video Resume</label>
                        <img src="../../assets/Info.svg" class="img-fluid red-tooltip" data-toggle="tooltip" data-placement="bottom"
                            alt="info" data-original-title="The video must be between 45 seconds to 120 seconds long"/>
                    </div>
                </div>
                <div class="row no-gutters mb-5">
                    <div class="col d-flex justify-content-center">
                        <button class="btn btn-light mt-4 proximanova borderradius20 fontsize14 black" @click="VideoResumeModalOpen">
                            <input type="file" class="form-control-file" id="exampleFormControlFile1"/>
                            <img :src="addresumevideoimage" class="img-fluid mr-2" alt="add"/><span id="addtextresume">Add</span>
                        </button>
                    </div>
                </div>
                <div class="row no-gutters vdtext">
                    <div class="col d-flex justify-content-center proximanova fontsize16 black60">Videos must be</div>
                </div>
                <div class="row no-gutters mb-5 vdtext">
                    <div class="col d-flex justify-content-center proximanova fontsize16 black60">between 45 to 120 seconds long</div>
                </div>
            </div>
            <div class="card shadow mb-4 overlay-gradient" v-else>
                <div>
                    <video height="272" oncontextmenu="return false" @ended="onenddisplayreplayIcon('resume')" @waiting="displayLoadingLogo('resume')" @canplay="stopLoadingLogo('resume')" controlsList="nodownload"  id="resumevideo" >
                        <source :src="savedResumeVideoLink">
                    </video>
                </div>
                <div class="card-img-overlay ">
                    <div class="row no-gutters mb-3 ml-0 mr-0 black_overlay1">
                        <div class="col ml-0 mt-3 d-flex videoheadsection">
                            <img src="../../assets/VideoProfile.svg" alt="videoprofile" class="img-fluid vdimage" />
                            <div class="d-flex flex-column">
                              <span class="fontsize14 proximanova-semibold white ml-2 mr-2 bold14px_white">Resume video</span>
                              <span class="ml-2 mr-2 fontsize14 proximanova-semibold white bold14px_white">{{savedResumeVideoDate | moment("ll") }}</span>
                            </div>
                        </div>
                        <div class="pr-2 pr-lg-4 pt-3">
                            <span class="more_optionmenu more_option" id="resumemoreactionpop" v-popover:videoResume>
                              <img src="../../assets/MoreActionsvideo.svg" width="4px" alt="moremenu" class="img-fluid" >
                            </span>
                            <popover name="videoResume" id="videoResume">
                              <div class="p-2">
                                  <div class="d-flex p-1 justify-content-between">
                                    <span class="fontsize12 text-nowrap proximanova-bold black">More Actions</span>
                                    <div class="closebtnmouseover">
                                      <img src="../../assets/closebtn.svg" alt="close" class="img-fluid pr-1 closebtn" @click="closeVideoMoreActions">
                                    </div>
                                  </div>
                                  <div class="d-flex p-1 action" @click="EditProfileResumeVideo('RESUME')">
                                      <img src="../../assets/Editvideo.svg" alt="edit" class="img-fluid pl-1 pr-1 ">
                                      <span class="pt-1 pl-2 d-flex flex-column">
                                        <div class="fontsize14 black80 proximanova">Edit</div>
                                      </span>
                                  </div>
                                  <!-- <div class="d-flex p-1 action">
                                      <img src="../../assets/Sharevideo.svg" alt="share" class="img-fluid pl-1 pr-1 ">
                                      <span class="pt-1 pl-2 d-flex flex-column">
                                        <div class="fontsize14 black80 proximanova">Share</div>
                                      </span>
                                  </div> -->
                                  <div class="d-flex p-1 action" data-toggle="modal" data-target="#deleteresumeVideoModal" @click="clickonDelete('resume')">
                                      <img src="../../assets/Deletevideo.svg" alt="delete" class="img-fluid pl-1  pr-1">
                                      <span class="pt-1 pl-1 d-flex ml-1 flex-column">
                                        <div class="fontsize14 black80 proximanova">Delete</div> 
                                      </span>
                                  </div>
                              </div>
                            </popover>
                            <div class="modal backgroundnone fade confirmmodal" id="deleteresumeVideoModal" tabindex="-1" role="dialog" aria-labelledby="deleteresumeVideoModalLabel" aria-hidden="true">
                              <div class="modal-dialog " role="document">
                                <div class="modal-content pb-2">
                                  <div class="modal-header delete-modal pb-0">
                                    <h5 class="modal-title fontsize20 black80 proximanova" id="deleteresumeVideoModalLabel">Are you sure you want to delete this record ?</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body backgroundcolorwhite modal-delete text-center">
                                    <span class="button-cancel-font modaldeletebtn pointer border borderradius20 p-2 pr-4 pl-4 proximanova" data-dismiss="modal" aria-label="Close" >No</span>
                                    <span class="button-cancel-font backgroundcolorblack pointer white p-2 ml-2 pr-4 pl-4 borderradius20 proximanova"  @click="deleteVideo(resumeVideoId,'resume')">Yes</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <img src="../../assets/play_video.svg" v-if="!playingResumeVideo" id="playvideobtn" alt="playvideo" @click="playResumeVideo">
                        <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingResumeVideo && replayResumeVideo">
                            <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo('resume')">
                        </div>
                        <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingResumeVideo && loadingResumeVideo">
                            <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                        </div>
                        <img src="../../assets/Pausevideo.svg" class="pausebtn" v-if="playingResumeVideo && !replayResumeVideo && !loadingResumeVideo" alt="pausevideo" @click="playResumeVideo">
                    </div>
                    <div id="bottom">
                        <div class="black_overlay2">
                            <div class="pb-3 d-flex flex-column p-3">
                              <span v-if="savedResumeVideoTitle" class="bold16px_white fontsize16 white proximanova-semibold text-capitalize">{{savedResumeVideoTitle}}</span>
                              <span v-if="savedResumeVideoDescription" class="reg16px_white proximanova fontsize16 white60 text-capitalize">{{savedResumeVideoDescription}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <profileresumemodal v-if="profileresumemodalopen" :profileresume="profileresumeobj" @close = "closeprofileresumeModal"></profileresumemodal>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
        <updatepostmodal v-if="updatepostvideomodal" :updatevideomyvidsection="updatingVideoObj" @close= "closeupdatepostmodal"></updatepostmodal>
    </div>
</template>
<script>
import $ from "jquery";
import profileresumemodal from '../../components/profileResumeModal.vue'
import sessionUtils from '../../js/session-util.js'
import httpuserprofile from "@/js/http-userprofile.js";
import updatepostmodal from '../../components/updatePostVideoModal.vue'
import { bus } from "../../main";
export default {
    props : ['userProfileDetails'],
    components : {
        profileresumemodal,
        updatepostmodal
    },
    data() {
        return{
            LoggedinuserId : sessionUtils.getUserId(),
            profileId : sessionUtils.getUserProfileId(),
            addprofilevideoimage : require('../../assets/Create_Video.svg'),
            addresumevideoimage : require('../../assets/Create_Video.svg'),
            profileVideoId : null,
            profileVideoDetails : null,
            resumeVideoId : null,
            resumeVideoDetails : null,
            profileresumemodalopen : false,
            profileresumeobj : {},
            //profile video
            replayProfileVideo : false,
            loadingProfileVideo : false,
            playingPorfileVideo : false,
            savedProfileVideoDate : null,
            savedProfileVideoTitle : null,
            savedProfileVideoDescription : null,
            savedProfileVideoLink : null,
            savedProfileVideoThumbnailLink : null,
            //resume video
            replayResumeVideo : false,
            loadingResumeVideo : false,
            playingResumeVideo : false,
            savedResumeVideoDate : null,
            savedResumeVideoTitle : null,
            savedResumeVideoDescription : null,
            savedResumeVideoLink : null,
            savedResumeVideoThumbnailLink : null,
            //profile video modal
            videoUploadingErrorMessage : null,
            savebuttonClicked : false,
            draftbuttonClicked : false,
            videoProfileClicked : false,
            videoResumeClicked : false,
            onProfileEditClicked : false,
            onResumeEditClicked : false,
            videothumnailSelected : false,
            uploadingVideoErrorMessage : '',
            recordVideo : null,
            recorder : null,
            setSource : null,
            beforeRcording : true,
            startedRcording : false,
            recordingPaused : false,
            displayControls : true,
            totalSeconds : 0,
            timer : null,
            selectVideoFromLocal : false,
            videoDetailsSection : true,
            videoTitle : '',
            videoDescription : '',
            videoProfileThumbnail : null,
            //update video
            updatepostvideomodal : false,
            updatingVideoObj : {},
            //api error
            displayAPIerrorModal : false
        }
    },
    mounted() {
        $('[data-toggle="tooltip"]').tooltip();
        if(this.userProfileDetails) {
          this.setData()
        }
        bus.$on("successfullysavedprofileresumevideo", data => {
            if(data){
                setTimeout(() => {
                    console.log("after profile saved")
                    this.updateProfileResumeVideoData(data)
                }, 1000)
            }
        })  
    },
    methods : {
        //setting the data from parent object to child component
        setData() {
          this.profileVideoId = this.userProfileDetails.profileVideoId;
          this.profileVideoDetails = this.userProfileDetails.profileVideoDetails;
          this.resumeVideoId = this.userProfileDetails.resumeVideoId; 
          this.resumeVideoDetails = this.userProfileDetails.resumeVideoDetails;
          //set profile video date
          if(this.userProfileDetails && this.userProfileDetails.profileVideoDetails && this.userProfileDetails.profileVideoId !== null) {
            if(this.userProfileDetails.profileVideoDetails.creationD !== null){
              this.savedProfileVideoDate = this.userProfileDetails.profileVideoDetails.creationD
            }
            if(this.userProfileDetails.profileVideoDetails.lastUpdatedD !== null) {
              this.savedProfileVideoDate = this.userProfileDetails.profileVideoDetails.lastUpdatedD
            }
            this.savedProfileVideoLink = this.userProfileDetails.profileVideoDetails.videoLink;
            this.savedProfileVideoThumbnailLink = this.userProfileDetails.profileVideoDetails.thumbnail;
            this.savedProfileVideoTitle = this.userProfileDetails.profileVideoDetails.videoTitle;
            this.savedProfileVideoDescription = this.userProfileDetails.profileVideoDetails.videoDescription;
          }
          //set resume video data
          if(this.userProfileDetails && this.userProfileDetails.resumeVideoDetails && this.userProfileDetails.resumeVideoId !== null){
            if(this.userProfileDetails.resumeVideoDetails.creationD !== null){
              this.savedResumeVideoDate = this.userProfileDetails.resumeVideoDetails.creationD
            }
            if(this.userProfileDetails.resumeVideoDetails.lastUpdatedD !== null) {
              this.savedResumeVideoDate = this.userProfileDetails.resumeVideoDetails.lastUpdatedD
            }
            this.savedResumeVideoLink = this.userProfileDetails.resumeVideoDetails.videoLink;
            this.savedResumeVideoThumbnailLink = this.userProfileDetails.resumeVideoDetails.thumbnail;
            this.savedResumeVideoTitle = this.userProfileDetails.resumeVideoDetails.videoTitle;
            this.savedResumeVideoDescription = this.userProfileDetails.resumeVideoDetails.videoDescription;
          }
        },
        // update profile and resume video data after succesfully saved
        updateProfileResumeVideoData(data){
            httpuserprofile.get("/userprofile/userbyid/" + this.LoggedinuserId)
            .then(response => {
                console.log(response)
                if(data == 'PROFILE'){
                    console.log("updating profile video")
                    this.profileVideoId = response.data.profileVideoId;
                    this.userProfileDetails.profileVideoId = response.data.profileVideoId;
                    this.userProfileDetails.profileVideoDetails = response.data.profileVideoDetails;
                    if(response.data.profileVideoDetails && response.data.profileVideoDetails.creationD !== null){
                        this.savedProfileVideoDate = response.data.profileVideoDetails.creationD
                    }
                    if(response.data.profileVideoDetails && response.data.profileVideoDetails.lastUpdatedD !== null) {
                        this.savedProfileVideoDate = response.data.profileVideoDetails.lastUpdatedD
                    }
                    var source = document.getElementById('profilevideosrctag')
                    if(source !== null && source !== undefined){
                        source.removeAttribute('src')
                    }
                    this.savedProfileVideoLink = response.data.profileVideoDetails.videoLink;
                    this.savedProfileVideoThumbnailLink = response.data.profileVideoDetails.thumbnail;
                    this.savedProfileVideoTitle = response.data.profileVideoDetails.videoTitle;
                    this.savedProfileVideoDescription = response.data.profileVideoDetails.videoDescription;
                    //send data to welcome page to update profile strength popoverdata
                    let obj = {
                        type : 'PROFILE',
                        id : this.profileVideoId,
                        videoDetails : this.userProfileDetails.profileVideoDetails
                    }
                    bus.$emit('updateProfileResumevideodataInWelcome', obj)
                }else{
                    console.log("updating resume video")
                    this.resumeVideoId = response.data.resumeVideoId;
                    this.userProfileDetails.resumeVideoId = response.data.resumeVideoId;
                    this.userProfileDetails.resumeVideoDetails = response.data.resumeVideoDetails;
                    if(response.data.resumeVideoId !== null) {
                        if(response.data.resumeVideoDetails && response.data.resumeVideoDetails.creationD !== null){
                        this.savedResumeVideoDate = response.data.creationD
                        }
                        if(response.data.resumeVideoDetails && response.data.resumeVideoDetails.lastUpdatedD !== null) {
                        this.savedResumeVideoDate = response.data.resumeVideoDetails.lastUpdatedD
                        }
                        this.savedResumeVideoLink = response.data.resumeVideoDetails.videoLink;
                        this.savedResumeVideoThumbnailLink = response.data.resumeVideoDetails.thumbnail;
                        this.savedResumeVideoTitle = response.data.resumeVideoDetails.videoTitle;
                        this.savedResumeVideoDescription = response.data.resumeVideoDetails.videoDescription;
                    }
                    //send data to welcome page to update profile strength popoverdata
                    let obj = {
                        type : 'RESUME',
                        id : this.resumeVideoId,
                        videoDetails : this.userProfileDetails.resumeVideoDetails
                    }
                    bus.$emit('updateProfileResumevideodataInWelcome', obj)
                }
            });
        },
        // this will invoke after click on create profile video on pending activities card
        // open modal component where user can able to upload a profile video
        VideoProfileModalOpen : function() {
            if(this.profileId){
                this.profileresumemodalopen = true;
                this.profileresumeobj.videoType = "profilevid"
            }else{
                this.displayNoProfileModalComponent = true;
            }
        },
        VideoResumeModalOpen : function() {
            if(this.profileId){
                this.profileresumemodalopen = true;
                this.profileresumeobj.videoType = "resumevid"
            }else{
                this.displayNoProfileModalComponent = true;
            }
        },
        //close profile/resume modal component
        closeprofileresumeModal() {
            this.profileresumemodalopen = false;
        },
        //play/pause profile & resume videos
        playResumeVideo : function() {
            var video = document.getElementById('resumevideo')
            var profileVideo = document.getElementById('profilevideo')
            if(!this.replayProfileVideo) {
            this.playingPorfileVideo = false;
            }
            if(!this.playingResumeVideo) {
                this.playingResumeVideo = true
                video.play()
                if(profileVideo) {
                profileVideo.pause()
                }
            }else{
                this.playingResumeVideo = false;
                video.pause()
            }
        },
        playProfileVideo() {
            var video = document.getElementById('profilevideo')
            var ResumeVideo = document.getElementById('resumevideo')
            if(!this.replayResumeVideo) {
            this.playingResumeVideo = false;
            }
            if(!this.playingPorfileVideo) {
                this.playingPorfileVideo = true
                video.play()
                if(ResumeVideo) {
                ResumeVideo.pause()
                }
            }else{
                this.playingPorfileVideo = false;
                video.pause()
            }
        },
        onenddisplayreplayIcon(type) {
            if(type == 'profile'){
                console.log("profile video")
                this.replayProfileVideo = true;
                this.loadingProfileVideo = false;
            }else if(type == 'resume') {
                console.log("resume video")
                this.replayResumeVideo = true;
                this.loadingResumeVideo = false;
            }
        },
        displayLoadingLogo(type) {
            if(type == 'profile'){
                if(this.playingPorfileVideo){
                this.loadingProfileVideo = true;
                }
            }else if(type == 'resume') {
                if(this.playingResumeVideo){
                this.loadingResumeVideo = true;
                }
            }
        },
        stopLoadingLogo(type) {
            if(type == 'profile'){
                if(this.playingPorfileVideo){
                this.loadingProfileVideo = false;
                }
            }else if(type == 'resume') {
                if(this.playingResumeVideo){
                this.loadingResumeVideo = false;
                }
            }
        },
        replayVideo(type) {
            if(type == 'profile'){
                this.replayProfileVideo = false;
                this.playingPorfileVideo = false;
                this.playProfileVideo()
            }else if(type == 'resume') {
                this.replayResumeVideo = false;
                this.playingResumeVideo = false;
                this.playResumeVideo()
            }
        },
        
        // this will invoke after click on close button on more actions menu (resume video)
        closeVideoMoreActions : function() {
            document.getElementById('resumemoreactionpop').click()
        },
        // this will invoke after click on close button on more actions menu (profile video)
        closeVideoMoreActionsProfile : function(){
            document.getElementById('moreactionprofilepop').click()
        },
        //clicking on delete button in moremenu popover to open delete confirmation modal
        clickonDelete(type) {
            if(type === 'profile'){
                let id1 = document.getElementById('moreactionprofilepop')
                id1.click()
                $('#deleteprofileVideoModal').modal('show')
            }
            if(type === 'resume'){
                let id2 = document.getElementById('resumemoreactionpop')
                id2.click()
                $('#deleteresumeVideoModal').modal('show')
            }
        },
        //this will invoke after click on delete button on moremenu popover to delete video
        deleteVideo : function(videoId, type){
            console.log("selected video id : ", videoId)
            console.log("type: ", type)
            var vm = this;
            httpuserprofile.delete("/userprofile/deleteVideo?profileId="+this.profileId+'&videoId='+videoId)
            .then((response) => {
                console.log(response)
                if(type === 'profile'){
                    //clear profile video data
                    this.savedProfileVideoLink = null;
                    this.userProfileDetails.profileVideoId = null;
                    this.userProfileDetails.profileVideoDetails = null;
                    this.savedProfileVideoThumbnailLink = null;
                    $('#deleteprofileVideoModal').modal('hide')
                    vm.$toast.success("Profile Video deleted successfully")
                    //clear profile percentage and profilevideo views
                    bus.$emit('reduceprofilePercentageAfterdeleteProfileResumeVideo', 'PROFILE');
                    bus.$emit('clearProfileVideoViewsInSidemenu', true)
                }
                if(type === 'resume'){
                    //clear resume video data
                    this.savedResumeVideoLink = null
                    this.savedResumeVideoThumbnailLink = null;
                    this.userProfileDetails.resumeVideoId = null;
                    this.userProfileDetails.resumeVideoDetails = null;
                    $('#deleteresumeVideoModal').modal('hide')
                    vm.$toast.success("Resume Video deleted successfully")
                    //clear profile percentage
                    bus.$emit('reduceprofilePercentageAfterdeleteProfileResumeVideo', 'RESUME');
                }
            }).catch((e)=> {
                console.log(e);
                if(type === 'profile'){
                    $('#deleteprofileVideoModal').modal('hide')
                }else if(type === 'resume'){
                    $('#deleteresumeVideoModal').modal('hide')
                }
                this.displayAPIerrorModal = true;
            })
        },
        //close API error modal
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        //this will invoke after click on edit option on moremenu popover to edit a draft video
        EditProfileResumeVideo : function(type) {
            console.log("editing obj : ", type)
            this.updatepostvideomodal = true;
            if(type == 'PROFILE'){
                this.updatingVideoObj = this.userProfileDetails.profileVideoDetails;
            }else{
                this.updatingVideoObj = this.userProfileDetails.resumeVideoDetails;
            } 
        },
        //this will invoke after click on cancel button on update video modal
        closeupdatepostmodal(returnObj) {
            this.updatepostvideomodal = false;
            console.log("close modal", returnObj)
            // if(returnObj.videoOriginalType === 'DRAFT' && returnObj.type === 'SUCCESS' && returnObj.videoType === 'POST'){
            //     this.draftVideosList.splice(this.selectedDraftVideoIndex, 1)
            //     this.draftVideosList.forEach((video,index) =>{
            //         video.moremenuname = 'popover'+index;
            //     })
            // }
            if(returnObj.videoIdentifier == 'RESUMEVIDEO' && returnObj.type === 'SUCCESS'){
                this.updateProfileResumeVideoData('RESUME')
            }
            if(returnObj.videoIdentifier == 'PROFILEVIDEO' && returnObj.type === 'SUCCESS'){
                this.updateProfileResumeVideoData('PROFILE')
            }
        }
    },
    beforeDestroy() {
        bus.$off("successfullysavedprofileresumevideo")
        bus.$off("reduceprofilePercentageAfterdeleteProfileResumeVideo")
        bus.$off("clearProfileVideoViewsInSidemenu")
    },
}
</script>
<style scoped>
.closebtn {
  cursor: pointer;
  width: 15px;
  height: 15px;
  padding: 2px;
  margin-top: -3px;
}
.more_option {
  cursor: pointer;
}
.more_optionmenu{
  padding: 0px 10px 3px 10px;
}
.more_optionmenu:hover{
  background-color: rgba(161, 166, 179,0.3);
  border-radius: 50%;
  margin-right: -1px;
  border: 1px solid rgba(161, 166, 179,.5);
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.card-header {
  border-radius: 8px !important;
}
[data-tooltip],
.tooltip {
  position: relative;
  cursor: pointer;
}
.card-img-overlay {
  padding: 0 !important;
}
.pausebtn{
  display: none;
}
.card-img-overlay:hover  .pausebtn{
  display: block;
  margin-left: 45%;
  margin-top: 15%;
  cursor: pointer;
}
.alert-danger1 {
  font-size: 15px !important;
}
.black_overlay1 {
  background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
  border-radius: 4px 4px 5px 4px;
  padding-bottom: 10px;
}
.black_overlay2 {
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%);
  border-radius: 0 4px 5px 4px;
}
.videoheadsection {
  padding-left: 8px !important;
  padding-right: 0px !important;
}
#profilevideo{
  width: 100%;
  border-radius: 4%;
  /* margin-bottom: -10.5px;
  margin-top: -4px; */
}
#resumevideo {
  width: 100%;
  border-radius: 4%;
}
#bottom {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
#playvideobtn {
  /* display: none; */
  margin-left: 45%;
  margin-top: 11%;
  cursor: pointer;
}
.modal-height{
  height: auto;
  margin-top: 5% !important;
  width: 100% !important;
  border-radius: 10px !important;
}

.modal-body{
  background-color: #000000
}
.modal{
  background-color: rgba(31,31,31,.89);
}
.modal-open .modal1 {
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(31,31,31,.8);
}
.modal-open .modal2{
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(31,31,31,.89);
}
.videomodalbody1{
  background-color: rgba(240,242,245,1);
  height: 300px !important;
}
.videomodalbody2 {
  background-color: rgba(240,242,245,.8);
  height: 280px ;
  overflow: auto;
}
.addVideoDetails {
  /* height: 205px; */
  margin-top: -5px;
}
/*hide scroll bar */
.videomodalbody2::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.videomodalbody2 {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.videoprofile {
  background-color: rgba(240,242,245,.8);
  padding: 0 !important;
}
#vid {
  width: 100%;
  /* margin-left: .20%; */
}
.modalbtn {
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modalbtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.modalbtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.modal-footer{
  background-color: #ffffff
}
.red-tooltip + .tooltip > .tooltip-inner {
  background-color: #fff;
  border: 1px solid #fff;
  color: black;
  padding: 15px;
  font-size: 20px;
}
/* Tooltip on bottom */
.test + .tooltip.bottom > .tooltip-arrow {
  border-bottom: 5px solid blue;
}
/* edit options on video */
.editbtn1 {
  position: absolute !important;
  margin-left: -60px;
  background-color: rgb(240,242,245);
  border: 1px solid blcck;
  color: black;
  right: 0;
  top: 0;
  margin-top: -100px;
  margin-right: 10px;
  z-index: 3;
}
.editbtn1:hover .dropdown-menu{
    display: block;
  }
  .dropdown-menu {
    width: 100px !important;
    min-width: 4rem !important;
    position: absolute;
    right: 0 !important;
  }
.dropdown-menu span{
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding-left: .7em;
  padding-right: .7em;
}
.dropdown-menu span:hover{
  background-color: #ddd;
}
#exampleFormControlFile1 {
  display: none;
}
#exampleFormControlFile2 {
  display: none;
}
#videoProfile.vue-popover.dropdown-position-bottom:before{
    display: none;
}
#videoProfile.dropdown-position-bottom {
  left: 55% !important;
  top: 45px !important;
  width: 150px !important;
  padding: 10px 0px 0px 10px !important;
}
#videoResume.dropdown-position-bottom {
  left: 55% !important;
  top: 45px !important;
  width: 150px !important;
  padding: 10px 0px 0px 10px !important;
}
#videoResume.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.action {
  cursor: pointer;
}
.action:hover {
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.editbtn2{
  width: 84px;
  position: absolute !important;
  margin-left: -60px;
  background-color: rgb(240,242,245);
  border: 1px solid blcck;
  color: black;
  right: 0;
  top: 0;
  margin-top: -250px;
  margin-right: 20px;
  z-index: 3;
}
.button {
  color: #1f1f1f !important;
}
.close{
  padding: 1px 7px 5px 7px !important;
  /* margin-top: 0px !important; */
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.closebtnmouseover1{
  border: 1px solid white;
  padding: 0 3px 0 3px;
}
.closebtnmouseover1:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.closebtnmouseover{
  padding-left: 5px;
  padding-right: 3px;
  margin-top: -4px;
  border: 1px solid white;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.rerecord{
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
  padding-right: 7px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.rerecord::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  padding-right: 5px;
	background-color :  rgba(31,31,31,.1);
}
.rerecord:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
video::-webkit-media-controls-fullscreen-button {
    display: none;
}
.confirmmodal{
  margin-top: 15%;
}
.delete-modal{
  border: none;
}
.modaldeletebtn{
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modaldeletebtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.modaldeletebtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.bold16px_white{
    font-size: 14px !important;
}
.reg16px_white {
    font-size: 14px !important;
}
.bold14px_white {
    font-size: 14px !important;
}
@media only screen and (max-width: 600px) {
  .vdtext {
    font-family: "Proxima Nova";
    word-wrap: break-word;
    text-align: center;
    width: 100%;
    padding-left: 0.35em;
  }
  .vdimage {
    height: 35px;
  }
}
@media screen and (min-width: 600px) {
  
}
@media screen and (max-width: 1024px) and (min-width: 769px) {
  #videoProfile.dropdown-position-bottom {
    left: 40% !important;
    width: 140px !important;
    padding: 10px 0px 0px 10px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 40% !important;
    width: 140px !important;
    padding: 10px 0px 0px 10px !important;
  }
}
@media screen and (max-width: 768px) and (min-width: 600px) {
  .pausebtn{
    margin-top: 16% !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  
}
@media screen and (max-width: 600px) and (min-width: 539px) {
  #videoProfile.dropdown-position-bottom {
    left: 45% !important;
    width: 140px !important;
    padding: 10px 0px 0px 10px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 45% !important;
    width: 140px !important;
    padding: 10px 0px 0px 10px !important;
  }
}
@media screen and (max-width: 539px) and (min-width: 400px) {
  .bold14px_white {
    font-size: 13px !important;
  }
  .bold16px_white {
    font-size: 13px !important;
  }
  .reg16px_white {
    font-size: 13px !important;
  }
  #videoProfile.dropdown-position-bottom {
    left: 28% !important;
    width: 140px !important;
    padding: 10px 0px 0px 10px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 28% !important;
    width: 140px !important;
    padding: 10px 0px 0px 10px !important;
  }
  .pausebtn{
    margin-top: 20% !important;
  }
}
@media screen and (max-width: 400px) and (min-width: 350px) {
  .modalbtn{
    padding: .175rem .3rem !important;
  }
  .bold14px_white {
    font-size: 12px !important;
  }
  .bold16px_white {
    font-size: 13px !important;
  }
  .reg16px_white {
    font-size: 13px !important;
  }
  #videoProfile.dropdown-position-bottom {
    left: 20% !important;
    width: 140px !important;
    padding: 10px 0px 0px 10px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 20% !important;
    width: 140px !important;
    padding: 10px 0px 0px 10px !important;
  }
  .pausebtn{
    margin-top: 20% !important;
  }
}
@media screen and (max-width: 350px) and (min-width: 300px) {
  .videomodalbody2{
    height: 350px !important;
  }
  .rerecord{
    padding: 0px !important;
  }
  .modalbtn{
    padding: .175rem .37rem !important;
  }
  #videoProfile.dropdown-position-bottom {
    left: 10% !important;
    width: 140px !important;
    padding: 8px 0px 0px 8px !important;
  }
  #videoResume.dropdown-position-bottom {
    left: 10% !important;
    width: 140px !important;
    padding: 8px 0px 0px 8px !important;
  }
  .bold14px_white {
    font-size: 12px !important;
  }
  .bold16px_white {
    font-size: 13px !important;
  }
  .reg16px_white {
    font-size: 13px !important;
  }
}
</style>